import React from 'react';
import { useParams } from 'react-router-dom';
import { Grid, Paper, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import FAuthPasswordReset from '../features/password-reset/FAuthPasswordReset';
import langAuthPasswordReset from '../features/password-reset/langs/langAuthPasswordReset';

const PAuthInvestorResetPassword = () => {
	const routeParams = useParams();
	const { t } = useTranslation();

	return (
		<Grid container spacing={3} alignItems="center" justifyContent="center">
			<Grid item sm={6} className="flex items-center">
				<Paper variant="elevation" style={{ padding: '36px', textAlign: 'center' }}>
					<Typography
						variant="h1"
						component="h1"
						style={{ fontWeight: 600, fontSize: '1.5rem', marginBottom: '24px' }}
					>
						{t(langAuthPasswordReset.title_reset_password.tag)}
					</Typography>
					<FAuthPasswordReset oktaRecoveryToken={routeParams.recoveryToken ?? ''} />
				</Paper>
			</Grid>
		</Grid>
	);
};

export default PAuthInvestorResetPassword;
